<template >
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">

      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <div class="d-flex justify-content-between">
          <p class="fw-bolder">
            ماتریس ارتباطات درونی / {{nameRoute}}</p>
          <div class="d-flex">
            <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
          </div>
        </div>
        <hr class="mt-3 mb-3">


        <div v-if="parseInt(type)===1">
          <table class="table table-striped" v-if="parseInt(type)===1">
            <tbody>
            <tr>
              <th></th>
              <th v-for="item1 in processes">{{item1.title}}</th>
            </tr>
            <tr v-for="item2 in processes">
              <td>{{item2.title}}</td>
              <td v-for="item1 in beneficiary">
                    <span v-for="item3 in supplierInputs">
                        <span v-if="item3.category_get_two_id===item1.id && item3.category_get_id===item2.id">{{item3.title}}</span>
                    </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div v-if="parseInt(type)===3 || parseInt(type)===4">
          <table class="table table-striped">
            <tbody>
            <tr>
              <th></th>
              <th v-for="item1 in headers">{{ item1.title }}</th>
            </tr>
            </tbody>
            <tr v-for="item2 in headers">
              <td>{{item2.title}}</td>
              <td v-for="item3 in headers">
                <span v-if="item3.children.length" v-for="(item4,index) in item3.children" >
                  <span v-if="item4.processes_id===item3.id && item2.id ===item4.processes_self_id">
                    {{item4.title}}
                  </span>
                  </span>
              </td>
            </tr>
          </table>
        </div>
        <div v-if="parseInt(type)===2 ">
          <table class="table table-striped" v-if="parseInt(type)===2">
            <tbody>
            <tr>
              <th></th>
              <th v-for="item1 in processes">{{item1.title}}</th>
            </tr>
            <tr v-for="item2 in processes">
              <td>{{item2.title}}</td>
              <td v-for="item1 in beneficiary">
                    <span v-for="item3 in supplierInputs">
                        <span v-if="item3.category_get_tree_id===item1.id && item3.category_get_four_id===item2.id">{{item3.title}}</span>
                    </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-if="parseInt(type)===5 ">
          <table class="table table-striped">
            <thead>
            <tr>
              <th></th>
              <th v-for="post in organization_posts">{{ post.name }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="process in process">
              <td>{{ process.title }}</td>
              <td v-for="post in organization_posts">
                <span v-for="task in tasks" >
                  <span v-if="task.processes_id === process.code && task.tasks_process_for_organizationposts.find(item => item.organizationposts_id === post.id)">
                    {{ task.title }}
                  </span>
                  </span>
              </td>
            </tr>
            </tbody>
          </table>

        </div>


      </div>
    </div>
  </div>


  <!--  modals *****************************-->


</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";

export default {
  name: 'HomeView',
  components: {
    Sidebar,
    splash
  },
  data(){
    return{
      showProcessFilter: false,
      select_inserter: false,
      inserterId: '',
      search_inserter: '',
      itemsOrgan: [],
      all_inserter: [],
      headers: [],
      sidebars: [],
      process: [],
      organization_posts: [],
      beneficiary: [],
      processes: [],
      supplierInputs: [],
      tasks: [],
      nameRoute: '',
      type: this.$route['params']['type'],
      id_route: this.$route['params']['id'],
    }
  },
  methods:{
    routeExport(){
      console.log(this.type)
      if (parseInt(this.type) ===1){
        this.nameRoute = 'طبقه'

      } if (parseInt(this.type) ===2) {
        this.nameRoute = 'گروه'
      } if (parseInt(this.type) ===3) {
        this.nameRoute = 'فرآیند'
      } if (parseInt(this.type) ===4) {
        this.nameRoute = 'زیر فرآیند'
      } if (parseInt(this.type) ===5) {
        this.nameRoute = 'پست سازمانی'
      } if (parseInt(this.type) ===6) {
        this.nameRoute = 'ذی نفع'
      }

    },
    all(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
        formdata.append('company_id',this.id_route)
      if (parseInt(this.type) ===1){
        formdata.append('level','1')

      } if (parseInt(this.type) ===2) {
        formdata.append('level','2')
      } if (parseInt(this.type) ===3) {
        formdata.append('level','3')
      } if (parseInt(this.type) ===4) {
        formdata.append('level','4')
      } if (parseInt(this.type) ===5) {
        formdata.append('level','5')
      }


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/MatrixConnections`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.headers){
              this.headers = [...response.headers]

            }
            if (response.sidebars){
              this.sidebars = [...response.sidebars]

            }
            if (response.process){
              this.process = [...response.process]
            }
            if (response.organization_posts){
              this.organization_posts = [...response.organization_posts]
            }
            if (response.tasks){
              this.tasks = [...response.tasks]
            }
            if (response.supplierInputs){
              this.supplierInputs = [...response.supplierInputs]
            }
            if (response.processes){
              this.processes = [...response.processes]
            }
            if (response.beneficiary){
              this.beneficiary = [...response.beneficiary]
            }
            setTimeout(() => {
              const cells = document.querySelectorAll("span");
              cells.forEach((cell, index) => {
                const cellContent = cell.innerText.trim();
                if (cellContent === '') {
                  // Remove empty spans
                  cell.remove();
                }
                // Check if there is a next sibling span
                const hasNextSibling = cell.nextElementSibling && cell.nextElementSibling.tagName === "SPAN";
                if (hasNextSibling) {
                  // Add a slash as a separator between cell content and the next one
                  cell.innerHTML = cellContent + '/';
                }
              });
            }, 1000);













          })
          .catch();
    },

    checkIsMother(){
      if (!this.is_mother){
        router.push('/pishkhan')
      }

    }
  },
  mounted() {
    this.checkIsMother()
    this.routeExport()
    this.all()



  },


}
</script>
<style scoped>
td:empty::before {
  content: "--";
}

</style>